import { useIntl } from 'react-intl';

import PlansScreen from '@/components/new-order/PlansScreen/PlansScreen';
import { resolveDiscountLabel } from '@/components/new-order/PlansScreen/PlansScreenAdapter';

import { useAffiliateDispatch, useAffiliateSelector } from '@/store/affiliate';
import { selectPlanAndProceed } from '@/store/affiliate/actions/planSelect';

import { type Plan } from '@/utils/mapProductObject';
import AnalyticsEventHandler from '@/services/analytics/AnalyticsEventHandler';
import { isExtensionUser } from '@/utils/appLinks';

const PlansScreenAdapter = () => {
  const intl = useIntl();

  const { plans, discountPercentage, isLoading, isWebRoute } = useAffiliateSelector((state) => {
    const { isInitializing } = state;

    return {
      discountPercentage: isInitializing ? undefined : state.plans.publicPlans[0]?.savePercentage,
      plans: state.plans.publicPlans,
      isLoading: isInitializing,
      isWebRoute: state.flags.isWebRoute,
    };
  });

  const dispatch = useAffiliateDispatch();
  const onPlanClick = (plan: Plan) => () => {
    void dispatch(selectPlanAndProceed(plan));

    const planName = plan.name.en.toLowerCase();

    if (isExtensionUser()) {
      AnalyticsEventHandler.trackExtensionUserTrialClick(plan.analyticsData.name);
    } else if (isWebRoute) {
      if (planName === '1 month') {
        AnalyticsEventHandler.trackWebPageMonthTrialClick();
      } else if (planName === '1 year') {
        AnalyticsEventHandler.trackWebPageYearTrialClick();
      }
    }
  };

  const discountLabel = resolveDiscountLabel(intl, plans, discountPercentage);

  return <PlansScreen plans={plans} isLoading={isLoading} discountLabel={discountLabel} onPlanClick={onPlanClick} />;
};

export default PlansScreenAdapter;
